import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-ivory px-4 py-14 md:py-16" data-id="element-79" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 rounded-3xl border border-charcoal/10 bg-white p-7 text-center shadow-sm md:flex-row md:p-10 md:text-left" data-id="element-80" data-mp="1o3doggt1mlt9">
        <div className="flex h-36 w-36 shrink-0 flex-col items-center justify-center rounded-full border-4 border-gold bg-forest text-ivory ring-4 ring-forest/15 ring-offset-4" data-id="element-81" data-mp="1x5mscntt3gxo">
          <ShieldCheckIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-82" data-mp="14gforafhw15k" />
          <span className="font-display text-4xl font-black leading-none" data-id="element-83" data-mp="1j4aimu58obk8">7</span>
          <span className="mt-1 text-[10px] font-black uppercase tracking-[.2em]" data-id="element-84" data-mp="1edu2v3dy4dup">Day guarantee</span>
        </div>
        <div data-id="element-85" data-mp="qnzryrd6szd3">
          <h2 className="font-display text-2xl font-black uppercase text-charcoal md:text-3xl" data-id="element-86" data-mp="qnhmr58jrat1">
            7-Day Guarantee
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-charcoal/80 md:text-base" data-id="element-87" data-mp="lowkl09qih1y">
            Take a look inside the material, review the volumes and explore how the 52-week system
            is organized.
          </p>
          <p className="mt-2 text-sm leading-relaxed text-charcoal/80 md:text-base" data-id="element-88" data-mp="tw9txdz6sidq">
            If you decide that Complete Stretching System 2026 isn't what you expected, contact us
            within 7 days of your purchase at{' '}
            <a href="mailto:compradigitalyaa@gmail.com" className="font-bold text-forest underline underline-offset-2" data-id="element-89" data-mp="61fgetguxc6c">
              compradigitalyaa@gmail.com
            </a>{' '}
            and request your refund within the guarantee period.
          </p>
        </div>
      </div>
    </section>;
}